import { Select, SelectProps } from 'antd';
import { useGetEmployeeQuery } from 'app/api';
import {
  selectSelectedCompanyGroupId,
  selectSelectedCompanyId,
} from 'app/containers/Company/slice/selectors';
import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { IOption } from 'types';

interface IProps extends SelectProps<number> {}

const EmployeeSelect: FC<IProps> = props => {
  const { t } = useTranslation();

  const envId = useSelector(selectSelectedEnvId) as number;
  const companyId = useSelector(selectSelectedCompanyId);
  const companyGroupId = useSelector(selectSelectedCompanyGroupId);

  const { data: employeeResponse, isFetching } = useGetEmployeeQuery(
    {
      companyId,
      companyGroupId,
      envId,
      pageSize: 1000,
      currentPage: 0,
      filters: {},
      sort: {},
    },
    { skip: !envId },
  );

  const options: IOption[] | undefined = employeeResponse?.content?.map(
    employee => ({
      value: employee.id,
      label: employee.firstName,
    }),
  );

  return (
    <Select
      options={options}
      loading={isFetching}
      placeholder={t('Common.Employee', 'Employee')}
      {...props}
    />
  );
};

export default EmployeeSelect;
